import { cn } from "@app/lib/utils";
import { useScrollAnimation } from "@design-system/hooks";
import { projectsAtom } from "@modules/home/atoms";
import { HomePageData } from "@modules/home/data/mockData";
import { useEffect } from "react";
import {
  HeroSection,
  OurSectorsSection,
  Projects,
  StatisticsMapSection,
  WhoWeAreSection,
} from "../components";

type HomePageProps = {
  data: HomePageData;
};

export function HomePage({ data }: HomePageProps) {
  // const { showScrollAnimation, handleAnimationComplete } = useScrollAnimation();

  useEffect(() => {
    projectsAtom.update(data.projects);
  }, []);

  return (
    <>
      {/* {!data?.hasSeenSplash && (
        <div>
          <Splash />
        </div>
    )} */}
      <div
        className={cn(
          "relative text-white",
          // showScrollAnimation && "lg:overflow-hidden",
        )}
      >
        {/* Scroll Animation Overlay */}
        {/* {showScrollAnimation && (
          <ScrollAnimation onAnimationComplete={handleAnimationComplete} />
        )} */}

        {/* Main Content - Only visible after animation */}
        <div
          className={cn(
            "-translate-y-[120px]",
            // showScrollAnimation ? "lg:pointer-events-none" : "",
          )}
        >
          <HeroSection data={data.hero} startAnimation={true} />
          <WhoWeAreSection />
          <OurSectorsSection />
          <StatisticsMapSection stats={data.statusSection} />
          <Projects />
          {/* <LatestNews posts={data.posts} /> */}
        </div>
      </div>
    </>
  );
}
